export const SMS_PHONE_MAX_LENGTH = 70;
export const SMS_MESSAGE_MAX_LENGTH = 300;

export const DEFAULT_SMS_CONTACT_NAME = "Laura";

export const DEFAULT_SMS_AVATAR = "/images/phone-previews/defaultPreview/sms.png";

export const formatPhoneNumber = (phoneNumber?: string): string => {
  if (!phoneNumber) {
    return "";
  }

  return phoneNumber.trim().replace(/\s+/g, " ");
};

export const clampMessage = (
  message?: string,
  maxLength: number = SMS_MESSAGE_MAX_LENGTH
): string => {
  if (!message) {
    return "";
  }

  return message.length > maxLength ? message.slice(0, maxLength) : message;
};

export const isValidSmsContent = (data?: { phoneNumber?: string; message?: string }): boolean => {
  const phoneNumber = formatPhoneNumber(data?.phoneNumber);
  const message = data?.message?.trim() ?? "";

  return (
    phoneNumber.length > 0 &&
    phoneNumber.length <= SMS_PHONE_MAX_LENGTH &&
    message.length > 0 &&
    message.length <= SMS_MESSAGE_MAX_LENGTH
  );
};
